import { motion } from 'framer-motion';

export default function PreLoader() {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-gray-900'>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        <div className='mx-auto mb-4 h-16 w-16 animate-spin rounded-full border-4 border-green-500 border-t-transparent' />
        <p className="text-green-500 text-lg">Initializing wallet...</p>
      </motion.div>
    </div>
  );
}
